export default [
  {
    path: '/consultar_personas/',
    name: 'consultar_personas',
    component: () => import('@/views/administracion/pages/personas/ConsultarPersonas.vue'),
    meta: {
      pageTitle: 'Personas',
      breadcrumb: [
        {
          text: 'Personas',
          to: '/consultar_personas'
        },
      
      ],
      requiresAuth: true,
      requiredPermission: 'per_consultar_persona',
      accion1: { url: '/persona/new/' },
      excel: false,
      pdf: false,
    },
  },
  {
    path: '/persona/new/',
    name: '/persona/new/',
    component: () => import('@/views/administracion/pages/personas/CrearPersona.vue'),
    meta: {
      pageTitle: 'Crear Persona',
      breadcrumb: [
        {
          text: 'Personas',
          to: '/consultar_personas' 
        },
      
      ],
      requiresAuth: true,
      requiredPermission: 'per_crear_persona',
      
      excel: false,
      pdf: false,
    },
  },
  {
    path: '/persona/edit/:id/',
    name: '/persona/edit/',
    component: () => import('@/views/administracion/pages/personas/EditarPersona.vue'),
    meta: {
      pageTitle: 'Crear Persona',
      breadcrumb: [
        {
          text: 'Personas',
          to: '/consultar_personas' 
        },
      
      ],
      requiresAuth: true,
      
      excel: false,
      pdf: false,
    },
  },
  
  {
    path: '/rol/',
    name: 'rol',
    component: () => import('@/views/usuario/Roles.vue'),
    meta: {
      pageTitle: 'Roles',
      breadcrumb: [
        {
          text: 'Usuario',
        },
        {
          text: 'Roles',
          active: true,
        },
      ],
      requiresAuth: true,
      accion1: { url: '/rol/new/' },
      excel: true,
      pdf: true,
    },
  },
  {
    path: '/rol/new/',
    name: 'formrol',
    component: () => import('@/views/usuario/Rol.vue'),
    meta: {
      pageTitle: 'Roles',
      breadcrumb: [
        {
          text: 'Usuario',
        },
        {
          text: 'Roles',
          to: '/rol/',
        },
        {
          text: 'Nuevo rol',
          active: true,
        },
      ],
      requiresAuth: true,
      // layout: 'full',
    },
  },
  {
    path: '/rol/edit/:token/',
    name: 'editrol',
    component: () => import('@/views/usuario/Rol.vue'),
    meta: {
      pageTitle: 'Roles',
      breadcrumb: [
        {
          text: 'Usuario',
        },
        {
          text: 'Roles',
          to: '/rol/',
        },
        {
          text: 'Editar rol',
          active: true,
        },
      ],
      requiresAuth: true,
      // layout: 'full',
    },
  },
  {
    path: '/permisos/:token/',
    name: 'permisos',
    component: () => import('@/views/usuario/AsignarPermiso.vue'),
    meta: {
      pageTitle: 'Permisos',
      breadcrumb: [
        {
          text: 'Usuario',
        },
        {
          text: 'Roles',
          to: '/rol/',
        },
        {
          text: 'Permisos rol',
          active: true,
        },
      ],
      requiresAuth: true,
      // layout: 'full',
    },
  },
  {
    path: '/usuario/',
    name: 'usuario',
    component: () => import('@/views/usuario/Usuarios.vue'),
    meta: {
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Usuario',
        },
        {
          text: 'Usuarios',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'usu_usuario_consultar', // si existe
      // layout: 'full',
      accion1: { url: '/usuario/new/' },
      excel: false,
      pdf: false,
    },
  },
  {
    path: '/usuario/new/',
    name: 'formusuario',
    component: () => import('@/views/usuario/UsuarioNew.vue'),
    meta: {
      pageTitle: 'Nuevo Usuario',
      breadcrumb: [
        {
          text: 'Usuario',
        },
        {
          text: 'Usuarios',
          to: '/usuario/',
        },
        {
          text: 'Nuevo usuario',
          active: true,
        },
      ],
      requiresAuth: true,
      // layout: 'full',
    },
  },
  {
    path: '/usuario/edit/:token/',
    name: 'editusuario',
    component: () => import('@/views/usuario/EditarUsuario.vue'),
    meta: {
      pageTitle: 'Editar Usuario',
      breadcrumb: [
        {
          text: 'Usuario',
        },
        {
          text: 'Usuarios',
          to: '/usuario/',
        },
        {
          text: 'Editar usuario',
          active: true,
        },
      ],
      requiresAuth: true,
      // layout: 'full',
    },
  },
  {
    path: '/log_actividad/',
    name: 'log_actividad',
    component: () => import('@/views/reporte/LogActividades.vue'),
    meta: {
      pageTitle: 'Log de actividades',
      breadcrumb: [
        {
          text: 'Reporte',
        },
        {
          text: 'Log de actividades',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'rep_log_actividades', // si existe
      excel: false,
      pdf: false,
      // layout: 'full',
    },
  },
  {
    path: '/mi-perfil/',
    name: 'mi-perfil',
    component: () => import('@/views/UserSettingsGeneral.vue'),
    meta: {
      pageTitle: 'Perfil',
      breadcrumb: [
        {
          text: 'Mi perfil',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
]
